enum RootTypes {
    ROOT_RESET = "ROOT_RESET",
}

export default RootTypes
